export const Functions = {
  create: true,
  delete: false,
  detail: false,
  search: false
};
export const PageName = '推荐码管理';